import { IBuildPrice } from 'hooks/price-order/types';
import { IPriceOrderDeliveryInput } from 'remote/queries/order';
import { UserDetails } from 'state/auth/hooks/use-current-user';
import { ServiceMode } from 'state/order';

export const buildPriceDeliveryInput = (
  order: Pick<
    IBuildPrice,
    'deliveryAddress' | 'deliveryPhoneNumber' | 'serviceMode' | 'tipCents' | 'deliveryInstructions'
  >,
  user: UserDetails
): IPriceOrderDeliveryInput | null => {
  if (order.serviceMode !== ServiceMode.DELIVERY || !order.deliveryAddress) {
    return null;
  }

  return {
    dropoff: {
      ...order.deliveryAddress,
      phoneNumber: order.deliveryPhoneNumber || user.details.phoneNumber || ''
    },
    instructions: order.deliveryInstructions,
    tipCents: order.tipCents
  };
};
